import React from 'react';
import { Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import { translate } from 'react-i18next';

/**
 * Componente Breadcrumbs cabeza (hace un nice breadcrumbs) similar al diseñado x michael.
 * 
 * USAGE
 * <Breadcrumbs links={[
 *      { href: '#/misreservas', label: 'Mis Reservas' },
 *      { href: "#/misreservas/" + this.state.idReserva + "/view", label: 'Detalle de la Reserva' },
 *      { href: 'javascript:history.back()', label: 'Cancelar Reserva' }
 *      ]} />
 */

import { navigateToFirstAllowedUrl } from './../components/SideBar/menudataprovider';
import { getUserInformation } from './../components/Login/loginService';

const appLinksMap = [
    
    {
        urlMatch: 'invoices$',
        links: [
            { label: 'PAGE_TITLES.Invoices', href: 'invoices' }
        ]
    },
    {
        urlMatch: 'results/.*',
        links: [
            { label: 'HOME.RESULTS', href: 'results/hotels/$2' }
        ]
    },
    {
        urlMatch: '.*/.*/reserve',
        links: [
            { label: 'HOME.RESULTS', href: 'results/hotels/$3' },
            { label: 'CONFIRM_BOOKING.CONFIRM_BOOKING', href: '' },
        ]
    },
    {
        urlMatch: 'owndata$',
        links: [
            { label: 'PAGE_TITLES.UserView', href: 'owndata' }
        ]
    },
    {
        urlMatch: 'agency$',
        links: [
            { label: 'PAGE_TITLES.AgencyView', href: 'agency' }
        ]
    },
    {
        urlMatch: 'users$',
        links: [
            { label: 'PAGE_TITLES.Users', href: 'users' }
        ]
    },
    {
        urlMatch: 'news$',
        links: [
            { label: 'PAGE_TITLES.NEWS', href: 'news' }
        ]
    },
    {
        urlMatch: 'promotions$',
        links: [
            { label: 'PAGE_TITLES.Promotions', href: 'promotions' }
        ]
    },
    {
        urlMatch: 'bookings$',
        links: [
            { label: 'HOME.BOOKINGS_MENU', href: 'bookings' }
        ]
    },
    {
        urlMatch: 'bookings/.*/view(.*)',
        links: [
            { label: 'PAGE_TITLES.Reservations', href: 'bookings' },
            { label: 'PAGE_TITLES.ReservationView', href: 'bookings/$1/view' }
        ]
    },
    {
        urlMatch: 'bookings/.*/cancel$',
        links: [
            { label: 'PAGE_TITLES.Reservations', href: 'bookings' },
            { label: 'PAGE_TITLES.ReservationView', href: 'bookings/$1/view' },
            { label: 'PAGE_TITLES.ReservationCancelView', href: 'bookings/$1/cancel' }
        ]
    },
    {
        urlMatch: 'bookings/.*/modify$',
        links: [
            { label: 'PAGE_TITLES.Reservations', href: 'bookings' },
            { label: 'PAGE_TITLES.ReservationView', href: 'bookings/$1/view' },
            { label: 'PAGE_TITLES.ReservationModifyView', href: 'bookings/$1/modify' }
        ]
    },
    {
        urlMatch: 'bookings/.*/confirm$',
        links: [
            { label: 'PAGE_TITLES.Reservations', href: 'bookings' },
            { label: 'PAGE_TITLES.ReservationView', href: 'bookings/$1/view' },
            { label: 'PAGE_TITLES.ReservationModifyView', href: 'bookings/$1/modify' },
            { label: 'PAGE_TITLES.ReservationModifyConfirm', href: 'bookings/$1/confirm' }
        ]
    },
    {
        urlMatch: 'news/.*$',
        links: [
            { label: 'PAGE_TITLES.NEWS', href: 'news' },
            { label: 'PAGE_TITLES.NEWSITEM', href: 'news/$1' }
        ]
    },
    {
        urlMatch: 'passwordreset$',
        links: [
            { label: 'PAGE_TITLES.ResetPasswordView', href: 'passwordreset' }
        ]
    },
    {
        urlMatch: 'tokengenerator$',
        links: [
            { label: 'PAGE_TITLES.TokenGeneratorView', href: 'tokengenerator' }
        ]
    },
];

const styles = theme => ({
    title: {
        color: 'var(--primary-text-color)',
        fontWeight: 700
    },
    breadcrumbsBar: {
        fontWeight: 'normal'
    },
    breadcrumbsBarTriangle: {
        width: 0,
        height: 0,
        borderTop: '5px solid transparent',
        borderBottom: '5px solid transparent',
        borderLeft: '5px solid',
        color: 'var(--primary-text-color)',
        marginTop: '5px',
        marginRight: '6px',
        float: 'left'
    },
    a: {
        textDecoration: 'none',
        color: 'var(--primary-text-color)',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
});

function getLinksWithPath() {
    let appLinks = appLinksMap;
    //  #/bookings/N19X031191X01/view
    let pagePaths = window.location.hash.replace('#/', '');
    let pageParts = pagePaths.split('/');
    appLinks = appLinks.filter(k => { return RegExp(k.urlMatch, 'gi').test(pagePaths); });
    if (appLinks && appLinks.length > 0) {
        let links = JSON.parse(JSON.stringify(appLinks[0].links));
        links.map(lk => {
            //lk.href = lk.href.replace('$0', pageParts[0]);
            if (pageParts.length >= 2) lk.href = lk.href.replace('$1', pageParts[1]);
            if (pageParts.length >= 3) lk.href = lk.href.replace('$2', pageParts[2]);
            if (pageParts.length >= 4) lk.href = lk.href.replace('$3', pageParts[3]);
        });
        return links;
    }
    return [];
}

class Breadcrumbs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            links: []
        };
    }
    componentDidMount() {
        window.addEventListener('hashchange', this.checkHash, false);
        this.checkHash();
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.checkHash, false);
    }
    checkHash = () => {
        let links = getLinksWithPath();
        this.setState({ links: links });
    }
    render() {
        let { classes, t, subPage } = this.props;
        let { links } = this.state;
        return <div className={classes.breadcrumbsBar}>
            <p className={classes.breadcrumbsBarTriangle}></p>
            <div>
                <Typography variant="body1" color="inherit" style={{ fontWeight: 300 }}>
                    <span>
                        <a className={classes.a}
                            style={{ cursor: 'pointer' }}
                            onClick={event => {
                                navigateToFirstAllowedUrl(null, subPage);
                            }}>
                            {t('COMMON.START')}
                        </a>&nbsp;/&nbsp;
                    </span>
                    {
                        links.map((item, index) => {
                            return <span key={index}>
                                <a className={classes.a} href={item.href !== '' ? '#/' + item.href : null}>
                                    {t(item.label)}
                                </a>
                                {index == links.length - 1 ? '' : ' / '}
                            </span>;
                        })
                    }
                </Typography>
            </div>
        </div>;
    }
}
export default translate('translations')(withStyles(styles)(Breadcrumbs));


// WEBPACK FOOTER //
// ./src/ui/Breadcrumbs.js